import HelloSign from 'hellosign-embedded';
import config from 'config';
export const helloSignClient = new HelloSign({
  clientId: config.hello_sign_client_id || '4abf6c4e85259f2bd4393a61d8b29be5',
  skipDomainVerification: process.env.NODE_ENV === 'development',
});
